const gains = [
  {
    icon: "ri-timer-flash-line",
    title: "Faster Response Times",
    description:
      "Automated triggers ensure leads and inquiries are acknowledged instantly—before your competitors respond.",
  },
  {
    icon: "ri-arrow-up-circle-line",
    title: "Increased Conversion Rates",
    description:
      "Structured follow-up sequences keep prospects engaged throughout every stage of the pipeline.",
  },
  {
    icon: "ri-layout-grid-line",
    title: "Operational Consistency",
    description:
      "Every client touchpoint follows the same structured process—regardless of team member or day.",
  },
  {
    icon: "ri-robot-2-line",
    title: "Reduced Manual Workload",
    description:
      "Repetitive tasks are automated so your team focuses on high-value work that actually grows revenue.",
  },
  {
    icon: "ri-star-smile-line",
    title: "Better Client Experience",
    description:
      "Clients receive fast, consistent, and professional communication from first contact to close.",
  },
];

export default function IndustryValue() {
  return (
    <section className="bg-[#0A0A0D] py-32 px-6 relative overflow-hidden">
      {/* Subtle background accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[#4ADE80]/5 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-end mb-20">
          <div>
            <p
              className="text-xs uppercase tracking-widest text-[#4ADE80] font-semibold mb-3"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Universal Benefits
            </p>
            <h2
              className="text-4xl md:text-5xl font-extrabold text-white leading-tight"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              What Every Industry Gains
            </h2>
          </div>
          <p
            className="text-white/40 text-base leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Regardless of your niche, GroundsWell AI delivers the same core
            outcomes—a more structured, reliable, and scalable business
            operation.
          </p>
        </div>

        {/* Gains Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {gains.map((item, idx) => (
            <div
              key={item.title}
              className={`bg-[#0F0F12] border border-white/8 rounded-2xl p-8 flex flex-col gap-4 hover:border-[#4ADE80]/20 transition-all duration-300 ${
                idx === 4 ? "lg:col-span-1 md:col-span-2" : ""
              }`}
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#4ADE80]/10 border border-[#4ADE80]/15">
                <i className={`${item.icon} text-[#4ADE80] text-xl`} />
              </div>
              <h4
                className="text-lg font-bold text-white"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {item.title}
              </h4>
              <p
                className="text-sm text-white/45 leading-relaxed"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Divider stat row */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/8 rounded-2xl overflow-hidden border border-white/8">
          {[
            { value: "< 2 min", label: "Average lead response time" },
            { value: "40%+", label: "Reduction in manual tasks" },
            { value: "100%", label: "Pipeline visibility at all times" },
          ].map((stat) => (
            <div key={stat.label} className="bg-[#0F0F12] px-10 py-8 text-center">
              <p
                className="text-3xl font-extrabold text-[#4ADE80] mb-1"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {stat.value}
              </p>
              <p
                className="text-sm text-white/40"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
